import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2baf3a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["alt"]
const _hoisted_2 = ["src"]

import { ref, onMounted, onUnmounted, computed } from 'vue';

export type LazyImageProps = {
  alt: string,
  src: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BlurImage',
  props: {
  src: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    default: '',
  },
  threshold: {
    type: Number,
    default: 0.1,
    required: false
  },
},
  emits: ['load'],
  setup(__props, { emit: __emit }) {

const props = __props;

const basePath = (process.env.BASE_URL === './' ? '/' : process.env.BASE_URL) + 'images';
const fileName = computed(() => {
  // return props.src.split('.')[0].split('img/')[1];
  return props.src.split('.')[0];
});
// const fileExtension = computed(() => props.src.split('.')[2]);

const srcWebp = `${basePath}/webp/${fileName.value}.webp`;
const srcAvif = `${basePath}/avif/${fileName.value}.avif`;
const blurSrc = `${basePath}/webp/${fileName.value}_blurred.webp`;

const container = ref(null);
const inViewport = ref(false);
const showBlur = ref(true);
const loaded = ref(false);
let observer: IntersectionObserver | null = null;
const aspectRatio = ref('1 / 1');
const emit = __emit;

const onLoad = (event: Event) => {
  loaded.value = true;
  const img = event.target as HTMLImageElement;
  aspectRatio.value = `${img.naturalWidth} / ${img.naturalHeight}`;
  emit('load');
};

onMounted(() => {
  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        inViewport.value = true;
        setTimeout(() => {
          showBlur.value = false;
        }, 1250);
        observer.disconnect();
      }
    });
  }, { threshold: props.threshold });
  observer.observe(container.value);
});

onUnmounted(() => {
  if (observer) observer.disconnect();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    ref_key: "container",
    ref: container,
    class: "blur-image",
    style: _normalizeStyle({ 'background-image':  showBlur.value ? `url(${blurSrc})` : '', 'aspect-ratio': aspectRatio.value })
  }, [
    _createElementVNode("picture", { alt: __props.alt }, [
      srcAvif
        ? (_openBlock(), _createElementBlock("source", {
            key: 0,
            srcset: srcAvif,
            type: "image/avif"
          }))
        : _createCommentVNode("", true),
      srcWebp
        ? (_openBlock(), _createElementBlock("source", {
            key: 1,
            srcset: srcWebp,
            type: "image/webp"
          }))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("img", {
        src: require(`@/assets/images/${__props.src}`),
        class: _normalizeClass([{ 'visible': inViewport.value }, "image"]),
        onLoad: onLoad
      }, null, 42, _hoisted_2), [
        [_vShow, loaded.value]
      ])
    ], 8, _hoisted_1)
  ], 4))
}
}

})